import { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

import { styled as MuiStyle } from '@mui/material/styles';
import {
    // Box,
    // Drawer,
    // CssBaseline,
    // Toolbar,
    List,
    Typography,
    Divider,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    // Avatar,
    Collapse,
    // Menu,
    // MenuItem,
    // Tooltip,
} from '@mui/material';

import {
    SideMenuDrawerContainer,
} from '../../../Styles/PageLayout/rootLayoutStyles';

import { 
    IconChevronLeft,
    IconChevronUp,
    IconChevronDown,
} from '@tabler/icons-react';

import { SideMenuInterface } from '../../../Models/PageLayout/SideMenu';

import GlobalFunctionHelper from '../../../Utilities/Helpers/GlobalFunctionHelper';

import { AssetImages } from '../../../Constants/Assets';
import { StaticDisplayText } from '../../../Constants/StaticDisplayTexts';
import { GlobalConstants } from '../../../Constants/GlobalConstants';

const DrawerHeader = MuiStyle('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export default function SideMenu(props: SideMenuInterface) {
    const location = useLocation();
	let {
        openDrawer,
        setOpenDrawer,
    } = props;

    //Use States
    const [openSubmenuIndex, setOpenSubmenuIndex] = useState(null);

    //Event Handlers
    const handleSubmenuOpen = (index: any) => {
        if(setOpenSubmenuIndex) {
            setOpenSubmenuIndex(index);
        }
    };

    const handleSubmenuClose = () => {
        if(setOpenSubmenuIndex) {
            setOpenSubmenuIndex(null);
        }
    };

    const handleDrawerClose = () => {
        if(setOpenDrawer) {
            setOpenDrawer(false);
        }
    };

    //Rendering Functions
    const renderSideMenuItem = (menu: any, index: number, isSub: boolean = false) => {
        var btnProps: any = {
            selected: location.pathname?.includes(menu.route),
            onClick: () => {
                handleSubmenuOpen(index == openSubmenuIndex ? null : index)
            }
        }
        if (!menu?.submenu) {
            btnProps = {
                ...btnProps,
                component: Link,
                to: menu.route
            }
        }
        return <>
            <ListItemButton sx={{ pl: isSub ? 4 : 2 }} {...btnProps}>
                <ListItem key={menu.title} disablePadding>
                    <ListItemIcon key={`btn${menu.title}`}
                        sx={{ py: 0, minWidth: 40 }}>
                        {menu.icon}
                    </ListItemIcon>
                    <ListItemText primary={menu.title} />
                </ListItem>
                {menu?.submenu ? index == openSubmenuIndex ? <IconChevronUp /> : <IconChevronDown /> : <></>}
            </ListItemButton>
        </>
    }

    return <SideMenuDrawerContainer
    sx={{
        width: (GlobalConstants?.DRAWER_WIDTH ?? 240),
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width: (GlobalConstants?.DRAWER_WIDTH ?? 240),
            boxSizing: 'border-box',
        },
    }}
    variant="persistent"
    anchor="left"
    open={openDrawer} >
        <DrawerHeader className="drawerHeader">
            <img className="appLogo" src={AssetImages.WEB_APP_LOGO} />
            <IconButton onClick={handleDrawerClose}>
                <IconChevronLeft />
            </IconButton>
        </DrawerHeader>

        <Divider />

        <List disablePadding>
            {GlobalFunctionHelper.getSideMenuItems()?.map((x: any, index: number) => (
                <>
                {renderSideMenuItem(x, index)}
                {<Collapse in={index == openSubmenuIndex} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {x?.submenu?.map((y: any, indexSub: number) => renderSideMenuItem(y, indexSub, true))}
                        </List>
                    </Collapse>}
                </>
            ))}
        </List>

        <Typography className="versionNum">{StaticDisplayText.VERSION_NUM}</Typography>
    </SideMenuDrawerContainer>
}